import { ErrorElement } from '@frontend/shared/web';
import { createBrowserRouter, Navigate } from 'react-router-dom';

import { constants, FEATURES } from '../../constants';
import { AcceptInvitationRoute } from '../../routes/accept-invitation-route/AcceptInvitationRoute';
import { AdminRoute } from '../../routes/admin-route';
import { AnonymousLayout } from '../../routes/anonymous-layout';
import { AuthenticatedLayout } from '../../routes/authenticated-layout';
import { HomeRoute } from '../../routes/HomeRoute';
import { IncidentsRoute } from '../../routes/incidents-route';
import { InvoicesRoute } from '../../routes/invoices-route';
import { LoginRoute } from '../../routes/login-route/LoginRoute';
import { LostFoundRoute } from '../../routes/lost-found-route';
import { NotFoundRoute } from '../../routes/not-found-route/NotFoundRoute';
import { PerformanceRoute } from '../../routes/performance-route';
import { RequireDomain } from '../../routes/RequireDomain';

export const routes = createBrowserRouter(
  [
    {
      element: <AnonymousLayout />,
      errorElement: <ErrorElement />,
      children: [
        { path: 'login', element: <LoginRoute />, errorElement: <ErrorElement /> },
        { path: 'not-found', element: <NotFoundRoute />, errorElement: <ErrorElement /> },
      ],
    },
    // Hors des deux layouts : un utilisateur connecté ne doit pas être renvoyé sur `/`.
    { path: 'invitation/accept', element: <AcceptInvitationRoute />, errorElement: <ErrorElement /> },
    {
      element: <AuthenticatedLayout />,
      errorElement: <ErrorElement />,
      children: [
        { path: '/', element: <HomeRoute />, errorElement: <ErrorElement /> },
        {
          path: 'incidents',
          element: (
            <RequireDomain domain="incidents">
              <IncidentsRoute />
            </RequireDomain>
          ),
          errorElement: <ErrorElement />,
        },
        {
          path: 'performance',
          element: (
            <RequireDomain domain="performance">
              <PerformanceRoute />
            </RequireDomain>
          ),
          errorElement: <ErrorElement />,
        },
        {
          path: 'invoices',
          element: (
            <RequireDomain domain="invoicing">
              <InvoicesRoute />
            </RequireDomain>
          ),
          errorElement: <ErrorElement />,
        },
        ...(FEATURES.lostFound
          ? [
              {
                path: 'lost-found',
                element: (
                  <RequireDomain domain="trips">
                    <LostFoundRoute />
                  </RequireDomain>
                ),
                errorElement: <ErrorElement />,
              },
            ]
          : []),
        {
          path: 'admin',
          element: (
            <RequireDomain domain="admin">
              <AdminRoute />
            </RequireDomain>
          ),
          errorElement: <ErrorElement />,
        },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/not-found" replace />,
    },
  ],
  {
    basename: constants.basename,
  },
);
